import DedicatedStoreFooter from "../DedicatedStoreFooter";
import type { PublicCompany } from "@/types/store";
import styles from "./automotive.module.css";

type Props = {
  company: PublicCompany;
  primaryColor?: string;
  formattedCnpj: string;
  address: string;
  attendanceLabel: string;
  instagramUrl: string;
  facebookUrl: string;
  hasFeatured: boolean;
  onFinancing?: () => void;
  onAppraisal?: () => void;
};

export default function AutomotiveFooter({
  company,
  primaryColor = "",
  instagramUrl,
  facebookUrl,
  onFinancing,
  onAppraisal,
}: Props) {
  return (
    <DedicatedStoreFooter
      company={company}
      primaryColor={primaryColor}
      fallbackColor="#ffffff"
      containerClassName={styles.container}
      instagramUrl={instagramUrl}
      facebookUrl={facebookUrl}
      institutional={
        <>
          <a href="#inicio">Início</a>
          <a href="#catalogo">Estoque</a>
          <a href="#sobre">A loja</a>
          <a href="#contato">Contato</a>
        </>
      }
      servicesLabel="Serviços da loja"
      services={
        <>
          {onFinancing && (
            <button type="button" onClick={onFinancing}>
              Financiamento
            </button>
          )}
          {onAppraisal && (
            <button type="button" onClick={onAppraisal}>
              Avalie seu carro
            </button>
          )}
        </>
      }
    />
  );
}
